import React, { useContext, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";

import { ReactComponent as File } from "../../asset/image/files_1.svg";
import { ReactComponent as Logo } from "../../asset/image/logo_1.svg";
import { ReactComponent as Edit } from "../../asset/icons/edit_or.svg";

import Smallscore from "../../asset/image/score-small.png";
import Bigscore from "../../asset/image/score-big.png";
import "./style.scss";
import { post } from "../../controlers/global/ConfigRequest";
import { CLOSE_MESSAGE_AUTOMATION } from "../../helperData/ApiAddress";
import { ToastContext } from "../../component/global/ToastContext";
import { useTranslation } from "react-i18next";

function Score({ size, score, title }) {
    const { t } = useTranslation();
    let count = 0;
    const finalScore = [];
    for (count; count < score; count++) {
        finalScore.push(
            <img src={size === "small" ? Smallscore : Bigscore} alt="score" />
        );
    }

    return (
        <div className="score">
            <div style={{ display: title === true ? "block" : "none" }}>
                {t("Src.Pages.Messages.ScoreModal.Score.Now")}
            </div>
            <div className="score-coins">{finalScore}</div>
        </div>
    );
}

const ScoreModal = ({
    showModal,
    setShowScoreModal,
    feedbackId,
    groupId,
    setPickupCloseBtnState,
    setFeedbackStatus,
    setAssignGroups,
    setMessageModalTabs,
}) => {
    const [file, setFile] = useState();
    const [fileName, setFileName] = useState();
    const [fileError, setFileError] = useState();
    const [enterNumber, setEnterNumber] = useState(false);
    const [scoreNumber, setScoreNumber] = useState(25);
    const [description, setDescription] = useState();
    const show = useContext(ToastContext);
    const { t } = useTranslation();

    const toBase64 = (files) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(files);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const getFileHandle = async (e) => {
        let files = e.currentTarget.files[0];

        let file64 = await toBase64(files);

        if (files.size?.toString() > 2024 * 2024) {
            setFileError(t("Src.Pages.Messages.ScoreModal.setFileError"));
            setFileName("");
            setFile("");
            return false;
        } else {
            setFileError("");
        }

        setFileName(files.name);

        setFile(file64);
    };

    const sendCloseFeedbackData = () => {
        setPickupCloseBtnState(true);
        post(CLOSE_MESSAGE_AUTOMATION.replace("{id}", feedbackId), {
            group: groupId,
            description,
            file,
        })
            .then((r) => {
                setFeedbackStatus([r.feedback_status]);
                setAssignGroups([]);
                setPickupCloseBtnState(false);
                setMessageModalTabs("commentDetails");
                setShowScoreModal(false);
                show(
                    t("Src.Pages.Messages.ScoreModal.CloseSuccess"),
                    "success",
                    t("Src.Pages.Messages.ScoreModal.CloseSuccess.Flag")
                );
                setEnterNumber(false);
                setScoreNumber(25);
                setDescription("");
                setFile();
                setFileName("");
            })
            .catch((e) => {
                show(
                    t("Src.Pages.Messages.ScoreModal.CloseDanger"),
                    "danger",
                    t("Src.Pages.Messages.ScoreModal.CloseDanger.Flag")
                );
                setShowScoreModal(false);
                setEnterNumber(false);
                setScoreNumber(25);
                setDescription("");
                setFile();
                setFileName("");
            })
            .finally((_) => setPickupCloseBtnState(false));
    };

    return (
        <Modal
            show={showModal}
            className="score_modal"
            id="feedback-score-modal"
        >
            <ModalBody>
                <div className="score_modal_main">
                    <Logo />
                    <File />
                    <span>
                        {t("Src.Pages.Messages.ScoreModal.Score.Label")}
                    </span>
                    <div className="score_box">
                        <div>
                            <div>
                                <button
                                    onClick={() =>
                                        setEnterNumber(
                                            (prevState) => !prevState
                                        )
                                    }
                                >
                                    <Edit />
                                </button>
                            </div>
                            <div className="score-number">{scoreNumber}</div>
                            <div className="score-count">
                                <div
                                    style={
                                        enterNumber
                                            ? { display: "block" }
                                            : { display: "none" }
                                    }
                                    onClick={() =>
                                        setScoreNumber(
                                            (prevState) => prevState + 1
                                        )
                                    }
                                >
                                    +
                                </div>
                                <div
                                    style={
                                        enterNumber
                                            ? { display: "block" }
                                            : { display: "none" }
                                    }
                                    onClick={() =>
                                        setScoreNumber(
                                            (prevState) => prevState - 1
                                        )
                                    }
                                >
                                    -
                                </div>
                            </div>
                            <Score size="small" score={2} />
                        </div>
                        <span>
                            {t(
                                "Src.Pages.Messages.ScoreModal.Score.Calc.Label"
                            )}
                        </span>
                    </div>

                    <div className="close-modal-message">
                        <label for="description">
                            {t(
                                "Src.Pages.Messages.ScoreModal.Score.Desc.Label"
                            )}
                        </label>
                        <textarea
                            id="description"
                            name="description"
                            rows="4"
                            cols="50"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="upload-file-container">
                        <label>
                            {t(
                                "Src.Pages.Messages.ScoreModal.Score.Upload.Label"
                            )}
                        </label>
                        <label htmlFor="upload-file">
                            <div className="input-like-div">
                                <p>
                                    {fileName
                                        ? fileName
                                        : t(
                                              "Src.Pages.Messages.ScoreModal.Score.Upload.btn.Label"
                                          )}
                                </p>
                            </div>
                            <input
                                type="file"
                                onChange={getFileHandle}
                                id="upload-file"
                                name="upload-file"
                            />
                        </label>
                        <div style={{ color: "red", whiteSpace: "nowrap" }}>
                            {fileError && fileError}
                        </div>
                    </div>
                    <div className="score_modal_btn">
                        <button onClick={sendCloseFeedbackData}>
                            {t(
                                "Src.Pages.Messages.ScoreModal.Score.close.btn.Label"
                            )}
                        </button>
                        <button onClick={() => setShowScoreModal(false)}>
                            {t(
                                "Src.Pages.Messages.ScoreModal.Score.cancel.btn.Label"
                            )}
                        </button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ScoreModal;
